import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { Vehicle } from '@/types/vehicle'

export function createVehicle(body: Vehicle): Promise<AxiosResponse<Vehicle>> {
  return instance.post(`/vehicle`, body)
}
